import axios from 'axios';

export const axiosInsight = axios.create({
	baseURL: 'https://universal-code.recity.in/v1',
	headers: { 'Content-Type': 'application/json' },
});
